<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
    </el-breadcrumb>
    <div style="position: relative">
      <el-alert type="warning" effect="dark" show-icon :closable="false">
        使用数据包导入，请先将符合平台要求的数据包从院感监测系统中导出，然后在此处导入平台
        <el-button size="mini" type="primary" @click="confrm">确认</el-button>
      </el-alert>
    </div>
    <p>
      <el-button type="text" @click="downLoad">下载感染监测上传数据包模板</el-button>
      <el-button type="text" @click="downLoadsws">下载手卫生上传数据包模板</el-button>
      <el-button type="text" @click="downLoadxhl">下载现患率上报xml模板</el-button>
    </p>
    <p>
      <el-button type="text" @click="downLoadc">操作手册下载(20250915)</el-button>
      <el-button type="text" @click="downLoadjh">数据交换规范下载(20250915)</el-button>
      <el-button type="text" @click="downLoadxhlsp">四川省医院感染现患率培训视频(2025)</el-button>
    </p>
    <el-dialog title="以下人员超过三年未参加市级以上感控培训：" :visible.sync="dialogTableVisible">
      <el-table :data="personData">
        <el-table-column align="center" sortable prop="Name" label="姓名">
        </el-table-column>
        <el-table-column align="center" sortable prop="Phone" label="联系电话">
        </el-table-column>
        <el-table-column align="center" sortable prop="Duties" label="职务">
        </el-table-column>
        <el-table-column align="center" sortable prop="zc" label="取得的职称">
        </el-table-column>
        <el-table-column align="center" sortable label="上一次参加感控培训等级">
          <template slot-scope="scope">
            {{ scope.row.Certificate }}
          </template>
        </el-table-column>
        <el-table-column align="center" sortable label="上一次参加市级以上感控培训时间">
          <template slot-scope="scope">
            {{ scope.row.lastTraining.split("T")[0] }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import { getPersonnelInfoByLastTraining, matchHospitalNumber } from "../../api/user";
export default {
  data() {
    return {
      personData: [],
      dialogTableVisible: false,
      hospitalNumber: "",
      loginUser: {}
    };
  },
  mounted() {
    this.loginUser = JSON.parse(localStorage.getItem("userdata"))[0];
    if (!this.loginUser.isUseSystem) {
      this.$alert('医院信息：是否使用院感信息系统未填写，请及时填写完整', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          sessionStorage.setItem('status', 'NO')
          this.$router.replace({ path: "/edit" });
        }
      });
    }
    this.hospitalNumber = this.loginUser.HospitalNumber;
    this.getData();
  },
  // 里面的函数只有调用才会执行
  methods: {
    getData() {
      matchHospitalNumber({ hospitalCode: this.hospitalNumber }).then((res) => {
        sessionStorage.setItem('status', '')
        if (res.data.length < 1) {
          this.$alert('医院账号信息与现患率调查平台账号不一致,请联系系统工程师修改医院编号。编号不一致会影响后续现患率数据上报', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              sessionStorage.setItem('status', 'NO')
              this.$router.replace({ path: "/edit" });
            }
          });
        }
      });
      getPersonnelInfoByLastTraining({ userID: this.hospitalNumber }).then((res) => {
        if (res.data.length > 0) {
          this.dialogTableVisible = true;
          this.personData = res.data;
        }
      });
    },
    downLoadc() {
      const url = "../../../static/20250915修-四川省医院感染质控平台操作手册.pdf";
      const elink = document.createElement("a");
      elink.href = url;
      elink.target = "_self"; // 当前也 target打开新页面
      elink.setAttribute("download", "20250915修-四川省医院感染质控平台操作手册.pdf");
      elink.style.display = "none";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    downLoadjh() {
      const url = "../../../static/20250915修-医院感染质控平台过程数据交换规范.pdf";
      const elink = document.createElement("a");
      elink.href = url;
      elink.target = "_self"; // 当前也 target打开新页面
      elink.setAttribute("download", "20250915修-医院感染质控平台过程数据交换规范.pdf");
      elink.style.display = "none";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    downLoadxhlsp() {
      const url = "../../../static/2025四川省医院感染现患率培训视频.zip";
      const elink = document.createElement("a");
      elink.href = url;
      elink.target = "_self"; // 当前也 target打开新页面
      elink.setAttribute("download", "2025四川省医院感染现患率培训视频.zip");
      elink.style.display = "none";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    downLoad() {
      const url = "../../../static/四川省医院感染质控平台数据上传模板.zip";
      const elink = document.createElement("a");
      elink.href = url;
      elink.target = "_self"; // 当前也 target打开新页面
      elink.setAttribute("download", "四川省医院感染质控平台数据上传模板.zip");
      elink.style.display = "none";
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    downLoadsws() {
      const url2 = "../../../static/手卫生数据上传模板.zip";
      const elink2 = document.createElement("a");
      elink2.href = url2;
      elink2.target = "_self"; // 当前也 target打开新页面
      elink2.setAttribute("download", "手卫生数据上传模板.zip");
      elink2.style.display = "none";
      document.body.appendChild(elink2);
      elink2.click();
      document.body.removeChild(elink2);
    },
    downLoadxhl() {
      const url2 = "../../../static/现患率调查2025.xml";
      const elink2 = document.createElement("a");
      elink2.href = url2;
      elink2.target = "_self"; // 当前也 target打开新页面
      elink2.setAttribute("download", "现患率调查2025.xml");
      elink2.style.display = "none";
      document.body.appendChild(elink2);
      elink2.click();
      document.body.removeChild(elink2);
    },
    confrm() {
      this.$router.push({ path: "/machine/Machine" });
    },
  },
};
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.stbgc {
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
  padding: 0px 16px;
}

.stsearch {
  text-align: center;
}

.text-c {
  text-align: center;
}

.st-gbox {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 5px;
  height: 30vh;
  box-sizing: border-box;
  padding: 10px;
}

.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.paybox {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 20px;
  height: 32vh;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/Goods.vue